const analyticsLoaderSelector = 'script[data-analytics-loader="google"]'

/**
 * Loads the optional Google Analytics library without a Promise. The upstream
 * vue-gtag loader leaves its script-load rejection unhandled when a privacy
 * tool or network failure blocks the provider. Analytics must never affect the
 * site, so a failed optional script is recorded on the element instead.
 */
export const appendOptionalAnalyticsScript = (document: Document, measurementId: string | undefined): boolean => {
  if (!measurementId || document.querySelector(analyticsLoaderSelector)) {
    return false
  }

  const script = document.createElement('script')
  script.async = true
  script.dataset.analyticsLoader = 'google'
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
  script.addEventListener('error', () => {
    script.dataset.loadState = 'failed'
  }, {once: true})
  document.head.append(script)

  return true
}
